import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { getBundlesByTruckloadGuid } from './bundles';
import { getProductionComponentInstancesByBundleGuid } from './getProductionComponentInstancesByBundleGuid';

export const getProductionComponentInstancesByTruckloadGuid = createSelector(
  (state: RootState) => state.truckloads,
  getBundlesByTruckloadGuid,
  getProductionComponentInstancesByBundleGuid,

  (truckloads, bundlesByTruckloadGuid, productionComponentInstancesByBundleGuid) =>
    mapValues(truckloads, (truckload) =>
      bundlesByTruckloadGuid[truckload.guid].flatMap((bundle) => productionComponentInstancesByBundleGuid[bundle.guid]),
    ),
);
